import React from 'react';

import { Icon } from '@components/index';

import { STEPPER_CONSTANTS, StepStatus } from '../../../../constants';

interface StepIconProps {
  status: StepStatus;
}

const StepIcon: React.FC<StepIconProps> = ({ status }) => {
  if (status === StepStatus.PENDING) {
    return (
      <div
        className="size-3.5 rounded-full"
        style={{ backgroundColor: STEPPER_CONSTANTS.COLORS.PENDING_BG }}
      />
    );
  }

  return (
    <div className="flex size-6 items-center justify-center">
      <Icon name="check-circle" className="size-5 text-green-600" />
    </div>
  );
};

export default StepIcon;
